import { AtonUnit, Coordinate } from "~/api/GeneratedApi";

export function getAtonLocation(aton: AtonUnit): Coordinate | null {
  if (!aton) return null;
  if (aton?.vatuLocation?.x && aton?.vatuLocation?.y) {
    return aton.vatuLocation;
  }
  if (aton?.installationLocation?.x && aton?.installationLocation?.y) {
    return aton.installationLocation;
  }
  if (aton?.measuredLocation?.x && aton?.measuredLocation?.y) {
    return aton.measuredLocation;
  }
  return null;
}
